import { render, staticRenderFns } from "./listadoalumnosporcurso.vue?vue&type=template&id=93d721ba&"
import script from "./listadoalumnosporcurso.vue?vue&type=script&lang=js&"
export * from "./listadoalumnosporcurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports